// extracted by mini-css-extract-plugin
export default {"info_block_wrapper":"CompareBlock_info_block_wrapper__NjFun","info_block":"CompareBlock_info_block__tZuYy"};